
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type TweetResponseMediaLinksItemLinkType = typeof TweetResponseMediaLinksItemLinkType[keyof typeof TweetResponseMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
